import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
import { useEffect, useState } from "react";
import { AttendeeInfo } from "../types/meeting.types";

interface UseAttendeePresenceProps {
  attendeeResponse: AttendeeInfo;
}

export const useAttendeePresence = ({
  attendeeResponse
}: UseAttendeePresenceProps) => {
  const [remoteAttendeeId, setRemoteAttendeeId] = useState<string | null>(null);
  const [hasRemoteParticipantLeft, setHasRemoteParticipantLeft] =
    useState<boolean>(false);
  const meetingManager = useMeetingManager();

  useEffect(() => {
    if (!meetingManager) return;

    const attendeePresence = (attendeeId: string, present: boolean) => {
      const localAttendeeId = attendeeResponse?.Attendee?.AttendeeId;

      if (present) {
        if (attendeeId !== localAttendeeId) {
          setRemoteAttendeeId(attendeeId);
          setHasRemoteParticipantLeft(false);
        }
      } else {
        if (attendeeId === remoteAttendeeId) {
          setHasRemoteParticipantLeft(true);
        }
      }
    };

    meetingManager?.audioVideo?.realtimeSubscribeToAttendeeIdPresence(
      attendeePresence
    );

    return () => {
      meetingManager?.audioVideo?.realtimeUnsubscribeToAttendeeIdPresence(
        attendeePresence
      );
    };
  }, [
    meetingManager,
    attendeeResponse?.Attendee?.AttendeeId,
    remoteAttendeeId
  ]);

  return {
    remoteAttendeeId,
    hasRemoteParticipantLeft,
    setRemoteAttendeeId,
    setHasRemoteParticipantLeft
  };
};
